import React from 'react';
import { Typography } from '../../../components/controls';
import { Box, Divider } from '@material-ui/core';

export default function TransactionsSummary(props) {
    const { title, value, colorize } = props;
    return (
        <Box justify="center" alignItems="center">
            <Typography variant="subtitle1">{title}</Typography>
            <Divider variant="middle" />
            <Typography
                status={colorize && value && value.length > 2 ? value.startsWith("-") ? "danger" : "success" : ""}
                style={{ marginTop: 5 }}
                variant="h6">{value}</Typography>
        </Box>
    );
}

